import React, { useState } from 'react';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/form.module';
import ListSmsPlans from './sms-plans';

const EMAIL_TEMPLATE_TYPE = 20;

export const TemplatesSmsInfoComponent = ({
  choosenSmsTemplate,
  selectedPlanId, setSelectedPlanId,
  handleInnerFormChange,
}: any) => {

  const [mappedEntities, setMappedEntities] = useState([]);

  const handlePlanIdChange = (planId: any, planData: any) => {
    if (planId && planData) {
      setMappedEntities([
        {
          Id: 0,
          OwnerTypeId: 70,
          OwnerId: planId,
          OwnerTypeName: 'EmailPlan',
          OwnerName: planData?.Name ?? 'string',
          Name: planData?.Name ?? 'string',
          Description: planData?.Description ?? 'string',
          IsFunction: true,
          IsDomain: false,
          MarketingTemplateId: 0,
          IsApproved: true,
          DisplayOrder: 0,
        },
      ]);
    }
  };

  return (
    <>

      <AccordionContainer
        child={
          <div className='w-full grid gap-4'>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <InputContainer
                label="Name"
                labelField="Name"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'Name');
                }}
                type="text"
                value={choosenSmsTemplate?.Name}
              />

               <InputContainer
                label="Subject"
                labelField="Subject"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(event.target.value, 'Subject');
                }}
                type="text"
                value={choosenSmsTemplate?.Subject}
              />
            </div>

      <div className='grid grid-cols-1'>
        <InputContainer
          label="BodyContent"
          labelField="BodyContent"
          className="h-60"
          onValueChange={(event: any) => {
            handleInnerFormChange(event, 'BodyContent');
          }}
          type="rte"
          readOnly
          value={choosenSmsTemplate?.BodyContent || "Dear User, We’re grateful to you for choosing us! Your support means the world to us. Ready to join our upcoming programs?, Check it out in our site. Thank You - DIGIIT Business Services"}
        />
      </div>
    </div>
  }
  expandedPanel="Basic Info"
  headerTitle="Basic Info"
/>

      <AccordionContainer
        child={
          <ListSmsPlans
            setSelectedPlanId={setSelectedPlanId}
            selectedPlanId={selectedPlanId}
            choosenSmsTemplate={choosenSmsTemplate}
            handleInnerFormChange={handleInnerFormChange}
            onPlanIdChange={handlePlanIdChange}
          />
        }
        expandedPanel="Plans"
        headerTitle="Select a Plan"
      />
    </>
  );
};

export default TemplatesSmsInfoComponent;
